<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean;
  isSidebar?: boolean;
}>();

defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const transitionName = computed(() => (props.isSidebar ? 'sidebar' : 'slide'));
</script>

<template>
  <Teleport to="#overlay">
    <Transition name="fade">
      <!-- add this to the div to enable closing when you click outside: @click="$emit('update:modelValue', false)" -->
      <div v-if="modelValue" class="background" />
    </Transition>
  </Teleport>

  <Teleport to="#overlay">
    <Transition :name="transitionName">
      <!-- The content stays rendered, so this transition never runs (WI 5799 S-motion 6a; fixed with the modals). -->
      <!-- eslint-disable-next-line vue/require-toggle-inside-transition -->
      <div class="overlay-content">
        <slot v-if="modelValue" @close="$emit('update:modelValue', false)" />
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped lang="scss">
.background {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(50, 50, 50, 0.8);
  z-index: 10;
}

.fade-enter-active,
.fade-leave-active {
  transition: all var(--duration-base) var(--ease-standard);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all var(--duration-slow) var(--ease-standard);
}
.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  margin-top: 5rem;
}

.sidebar-enter-active,
.sidebar-leave-active {
  transition: all var(--duration-slow) var(--ease-standard);
}
.sidebar-enter-from,
.sidebar-leave-to {
  opacity: 0;
  margin-right: -5rem;
}
</style>
